<template>
    <div class='bg-white px-3 index' :style="{height:height}">
        <img src="../../../assets/imgs/home/icon.png" alt="" style="width:200px">
        <img class="welcome" src="../../../assets/imgs/home/welcome.png" alt="">
    </div>
</template>

<script>
    export default {
        components: {},
        data() {
            return {
                height: null
            };
        },
        watch: {},
        computed: {},
        created() {},
        mounted() {
            this.getHeight()
        },
        methods: {
            getHeight() {
                let that = this
                that.height = window.innerHeight  -150 + 'px'
                window.onresize = () => {
                    that.height = window.innerHeight  - 150 + 'px'
                }
            },
        },
    };
</script>
<style lang="scss" scoped>
    .index {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .welcome{
            padding: 50px 0 25px;
            width: 700px;
        }
    }
</style>